<template>
  <div>
    <HeaderCont />
    <TitleCont name1="movie" name2="reference api" />
    <div class="pop__movie">
      <div class="container">
        <div class="pop__inner">
          <swiper
            :effect="'coverflow'"
            :grabCursor="true"
            :centeredSlides="true"
            :slidesPerView="'auto'"
            :initialSlide="5"
            :autoplay="{
              delay: 2500,
              disableOnInteraction: false,
            }"
            :coverflowEffect="{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: false,
            }"
            :pagination="true"
            :modules="modules"
            class="mySwiper"
          >
            <swiper-slide v-for="slider in sliders" :key="slider.id"
              ><li>
                <a :href="`https://www.themoviedb.org/movie/${slider.id}`">
                  <img
                    :src="`https://image.tmdb.org/t/p/w500/${slider.poster_path}`"
                    :alt="slider.title"
                  />
                  <em>
                    <span class="title">{{ slider.title }}</span>
                    <span class="star">{{ slider.vote_average }}</span>
                  </em>
                </a>
              </li></swiper-slide
            >
          </swiper>
        </div>
      </div>
    </div>
    <!-- //pop__movie -->

    <div class="movie__search">
      <div class="container">
        <h2>검색하기</h2>
        <form @submit.prevent="SearchMovies()">
          <input
            :ref="inputRef"
            :type="search"
            placeholder="검색하세요!"
            :onKeyPress="onKeyPress"
            v-model="search"
          />
          <button type="submit" :onClick="onClick">검색</button>
        </form>
      </div>
    </div>
    <!-- //movie__search -->

    <section class="cont__movie">
      <div class="container">
        <div class="movie__inner">
          <div class="movie__slider"></div>
          <div class="movie__search"></div>
          <div class="movie__movies">
            <div class="container">
              <div class="movie__list">
                <ul>
                  <li v-for="movie in movies" :key="movie.id">
                    <a :href="`https://www.themoviedb.org/movie/${movie.id}`">
                      <img
                        :src="`https://image.tmdb.org/t/p/w500/${movie.poster_path}`"
                        :alt="movie.title"
                      />
                      <em>
                        <span class="title">{{ movie.title }}</span>
                        <span class="star">{{ movie.vote_average }}</span>
                      </em>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- //cont__movie -->
    <ContactCont />
    <FooterCont />
  </div>
</template>

<script>
import HeaderCont from "@/components/HeaderCont.vue";
import TitleCont from "@/components/TitleCont.vue";
import ContactCont from "@/components/ContactCont.vue";
import FooterCont from "@/components/FooterCont.vue";
import { ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";

import "swiper/css";

import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

// import "./style.css";

import { EffectCoverflow, Pagination, Autoplay } from "swiper";

export default {
  components: {
    HeaderCont,
    TitleCont,
    ContactCont,
    FooterCont,
    Swiper,
    SwiperSlide,
  },

  setup() {
    const movies = ref([]);
    const sliders = ref([]);
    const search = ref("marvel");

    const SearchMovies = async () => {
      await fetch(
        `https://api.themoviedb.org/3/search/movie?api_key=657bc92cb91cb42e311f58ddd303bff6&query=${search.value}&page=1`
      )
        .then((response) => response.json())
        .then((result) => {
          movies.value = result.results;
          search.value = "";
        })
        .catch((error) => console.log(error));
    };
    SearchMovies();

    const TopMovies = async () => {
      await fetch(
        "https://api.themoviedb.org/3/movie/popular?api_key=657bc92cb91cb42e311f58ddd303bff6&language=ko-KR&page=1"
      )
        .then((response) => response.json())
        .then((result) => (sliders.value = result.results))
        .catch((error) => console.log(error));
    };
    TopMovies();

    return {
      movies,
      sliders,
      search,
      SearchMovies,
      TopMovies,
      modules: [EffectCoverflow, Pagination, Autoplay],
    };
  },
};
</script>

<style lang="scss">
.movie__inner {
  ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    li {
      width: 23%;
      position: relative;
      transition: transform 0.3s;

      &:hover {
        transform: translateY(-20px);
      }

      em {
        display: block;
        margin-bottom: 30px;
        font-family: var(--font-sub3);
      }

      .title {
        display: inline-block;
        padding: 5px 0;
      }

      .star {
        background: #fff;
        color: #000;
        position: absolute;
        left: 10px;
        top: 10px;
        width: 30px;
        height: 30px;
        border-radius: 100px;
        text-align: center;
        line-height: 30px;
        font-weight: 800;
        z-index: 1;
      }

      .rank__desc {
        .rank {
          position: absolute;
          right: 10px;
          top: 0;
          color: white;
          font-size: 50px;
          font-weight: 800;
          font-family: var(--font-sub2);
          text-shadow: 0 0 10px black, 0 0 10px black;
        }
      }
    }
  }

  a {
    color: var(--black);
  }
}

.movie__search {
  margin-bottom: 100px;

  .container {
    position: relative;
  }

  h2 {
    color: var(--black);
    font-size: 40px;
    text-indent: -9999px;
    height: 0;
  }
  input {
    background: var(--white);
    border: 2px solid var(--black);
    border-radius: 50px;
    color: var(--black);
    width: 100%;
    padding: 15px 30px;
    font-family: var(--font-sub3);
    margin-top: 50px;
  }
  button {
    position: absolute;
    right: 0;
    top: 50px;
    width: 100px;
    height: 56px;
    border-radius: 50px;
    border: 0;
    font-family: var(--font-sub3);
    background-color: #212121;
    color: var(--white);
    cursor: pointer;
    z-index: 1000;
  }
}

.pop__movie {
  h2 {
    color: var(--black);
    font-size: 30px;
    height: 0;
    display: inline-block;
    font-family: var(--font-sub3);
  }

  .pop__inner {
    div.swiper {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding-bottom: 50px;
      position: relative;

      .swiper-pagination-bullet {
        background: var(--black);
      }
      li {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: -30px;
        transition: transform 0.3s;
        position: relative;

        &:hover {
          transform: translateY(-20px);
        }

        .rank__desc {
          .rank {
            position: absolute;
            right: 10px;
            top: 0;
            font-size: 50px;
            font-weight: 800;
            font-family: var(--font-sub2);
            text-shadow: 0 0 10px black, 0 0 10px black;
          }
        }

        em {
          display: block;
          font-family: var(--font-sub3);
        }

        .title {
          display: inline-block;
          color: black;
          font-size: 18px;
          margin-top: 10px;
        }
        .star {
          background: #fff;
          color: #000;
          position: absolute;
          left: 10px;
          top: 10px;
          width: 30px;
          height: 30px;
          border-radius: 100px;
          text-align: center;
          line-height: 30px;
          font-weight: 800;
          z-index: 1;
        }

        .switer-slide {
          position: relative;
        }
      }
    }
  }

  // ul {
  //     display: flex;
  //     justify-content: space-between;
  //     flex-wrap: wrap;
  //     margin-top: 30px;

  //     li {
  //         width: 18%;
  //         position: relative;
  //         transition: transform 0.3s;

  //         &:hover {
  //             transform: translateY(-20px);
  //         }

  //         .rank__desc {
  //             .rank {
  //                 position: absolute;
  //                 right: 10px;
  //                 top: 0;
  //                 font-size: 50px;
  //                 font-weight: 800;
  //                 font-family: var(--font-sub2);
  //                 text-shadow: 0 0 10px black, 0 0 10px black;
  //             }
  //         }

  //         em {
  //             display: block;
  //             height: 80px;
  //             margin-bottom: 30px;
  //             font-family: var(--font-sub3);
  //         }

  //     }
  // }

  a {
    color: var(--white);
  }
}
</style>

<style lang="css">
#app {
  height: 100%;
}
html,
body {
  position: relative;
  height: 100%;
}

body {
  background: #eee;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #000;
  margin: 0;
  padding: 0;
}

.swiper {
  width: 100%;
  padding-top: 50px;
  padding-bottom: 50px;
  height: 600px;
}

.swiper-slide {
  background-position: center;
  background-size: cover;
  width: 300px;
  height: 300px;
}

.swiper-slide img {
  display: block;
  width: 100%;
}
</style>
